import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SessionService } from '@core/services/session.service';

export const AuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const sessionService = inject(SessionService);

  return from(sessionService.hydrateSessionContext()).pipe(
    map(({ user }) => {
      if (!user) {
        router.navigate(['/auth/login']);
        return false;
      }
      return true;
    }),
    catchError(() => {
      router.navigate(['/auth/login']);
      return of(false);
    })
  );
};
